import React from "react";
import "./RoadTransport.css";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Rejects from "./accpentAndReject/Rejects";
import Approve from "./accpentAndReject/Approve";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const Closed = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="tabelMain">
      <div>
        <Paper className={classes.root}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Accepted" className="tab" />
            <Tab label="Rejected" className="tab" />
          </Tabs>
        </Paper>
      </div>
      {value === 1 && <Rejects />}
      {value === 0 && <Approve />}
    </div>
  );
};

export default Closed;
